module.exports = __webpack_public_path__ + "img/Login.87b31755.png";